import React, { FC, useState, useEffect } from "react";
import { AppMaterialIcons } from "../Icons";
import { IconButton } from "@mui/material";

interface TextToSpeechButtonProps {
  text: string;
}

const TextToSpeechButton: FC<TextToSpeechButtonProps> = ({ text }) => {
  const [isPaused, setIsPaused] = useState(false);
  const [voice, setVoice] = useState<any>();
  const [isPlaying, setIsPlaying] = useState(false);

  useEffect(() => {
    const loadVoices = () => {
      const synth = window.speechSynthesis;
      const voices = synth.getVoices();
      if (voices.length > 7) {
        // Use voice at index 7 if available
        setVoice(voices[7]);
      } else if (voices.length > 0) {
        // Fallback to first voice if index 7 is not available
        setVoice(voices[0]);
      }
    };

    // Load voices immediately
    loadVoices();
    
    // Also listen for voiceschanged event (needed for some browsers)
    if (typeof window.speechSynthesis.addEventListener === 'function') {
      window.speechSynthesis.addEventListener('voiceschanged', loadVoices);
    }

    // Cleanup event listener on unmount
    return () => {
      if (typeof window.speechSynthesis.removeEventListener === 'function') {
        window.speechSynthesis.removeEventListener('voiceschanged', loadVoices);
      }
    };
  }, []);

  const textWithoutHtml = text.replace(/<[^>]*>/g, "");

  const handlePlay = () => {
    // Ensure voice is set before playing
    if (!voice) return;
    
    const utterance = new SpeechSynthesisUtterance(textWithoutHtml);
    utterance.voice = voice;
    utterance.rate = 1.0;
    utterance.pitch = 1.0;

    // Call the chunking function with optimized settings
    speechUtteranceChunker(utterance, { 
      chunkLength: 200,
      rate: 1.0,
      overlap: 50,
      voice: voice // Pass the voice to the chunker
    }, () => {
      handleStop();
    });

    setIsPaused(false);
    setIsPlaying(true);
  };

  const handlePause = () => {
    const synth = window.speechSynthesis;
    synth.pause();
    setIsPaused(true);
  };

  const handleStop = () => {
    const synth = window.speechSynthesis;
    synth.cancel();
    setIsPaused(false);
    setIsPlaying(false);
  };

  const handleTogglePlay = () => {
    if (isPlaying) {
      handleStop();
    } else {
      handlePlay();
    }
  };

  return (
    <div>
      {/* <button onClick={handlePlay}>{isPaused ? "Resume" : "Play"}</button>
      <button onClick={handlePause}>Pause</button>
      <button onClick={handleStop}>Stop</button>
      <button onClick={handleTogglePlay}>{isPlaying ? "Stop" : "Play"}</button> */}
      <IconButton onClick={handleTogglePlay} disableRipple={true}>
        <AppMaterialIcons
          style={{ fontSize: "18px" }}
          iconName={isPlaying ? "VolumeOffOutlined" : "VolumeDownOutlined"}
        />
      </IconButton>
    </div>
  );
};

var speechUtteranceChunker = function (utt: any, settings: any, callback: any) {
  settings = settings || {};
  var chunkLength = (settings && settings.chunkLength) || 200;
  var rate = (settings && settings.rate) || 1.0;
  var overlap = (settings && settings.overlap) || 0;
  var voice = settings.voice; // Get voice from settings
  var txt = settings && settings.offset !== undefined
    ? utt.text.substring(settings.offset)
    : utt.text;

  let chunks = splitTextByLength(txt, chunkLength);

  var currentChunk = 0;

  function speakNextChunk() {
    if (currentChunk < chunks.length) {
      var chunk = chunks[currentChunk];
      var newUtt: any = new SpeechSynthesisUtterance(chunk);

      // Copy all properties except text
      for (var prop in utt) {
        if (utt.hasOwnProperty(prop) && prop !== "text") {
          newUtt[prop] = utt[prop];
        }
      }

      newUtt.rate = rate;
      newUtt.voice = voice;

      // Add a small delay between chunks to prevent overlap
      newUtt.onend = function () {
        currentChunk++;
        setTimeout(speakNextChunk, 50); // Small delay between chunks
      };

      speechSynthesis.speak(newUtt);
    } else {
      if (callback !== undefined) {
        callback();
      }
    }
  }

  speakNextChunk();
};

function splitTextByLength(text: any, maxLength: any) {
  const words = text.split(" ");
  const resultArray = [];
  let currentLine = "";

  for (const word of words) {
    if ((currentLine + " " + word).length <= maxLength) {
      currentLine += " " + word;
    } else {
      resultArray.push(currentLine.trim());
      currentLine = word;
    }
  }

  if (currentLine.length > 0) {
    resultArray.push(currentLine.trim());
  }

  return resultArray;
}

export default TextToSpeechButton;
